export const inr = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  return "₹" + Number(n).toLocaleString("en-IN", { maximumFractionDigits: 0 });
};

export const inrShort = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "₹0";
  const v = Number(n);
  if (Math.abs(v) >= 10000000) return "₹" + (v / 10000000).toFixed(2) + "Cr";
  if (Math.abs(v) >= 100000) return "₹" + (v / 100000).toFixed(2) + "L";
  if (Math.abs(v) >= 1000) return "₹" + (v / 1000).toFixed(1) + "K";
  return "₹" + v.toFixed(0);
};

export const pct = (n) => {
  if (n === null || n === undefined || isNaN(n)) return "0%";
  return (Number(n) * 100).toFixed(1) + "%";
};

export const fmtDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch { return d; }
};
